export interface ICombinationConfig {
  masterKeyApiUrl: string;
  isAlohomora: boolean;
}

export class CombinationConfig {
  private readonly _masterKeyApiUrl: string;
  private readonly _isAlohomora: boolean;

  private constructor(masterKeyApiUrl: string, isAlohomora: boolean) {
    this._masterKeyApiUrl = masterKeyApiUrl;
    this._isAlohomora = isAlohomora;
  }

  public static createConfig(configProps: ICombinationConfig): CombinationConfig {
    if (!configProps.masterKeyApiUrl) {
      throw new Error(`KeyingHierarchyConfig cannot be created.`);
    }

    return new CombinationConfig(configProps.masterKeyApiUrl, configProps.isAlohomora);
  }

  public getKeyingUrl(): string {
    if (!this._isAlohomora) {
      return `${this._masterKeyApiUrl}/v1.0`;
    }

    return `${this._masterKeyApiUrl}/v1.0`;
  }
}
